// Function to add custom pricing and scent labels to Searchanise products
function enhanceSearchaniseProducts() {
  // update cart button text
  const buttons = document.querySelectorAll('.collection-grid-section .snize-add-to-cart-button');
  buttons.forEach((button, index) => {
    const oldText = button.textContent;
    button.textContent = 'Add';
    // console.log(`Button ${index + 1} updated: "${oldText}" → "Cart"`);
  });
  
  // console.log('Starting product enhancement function');
  document.body.classList.add('custom-collection-page');
  const productDataElements = document.querySelectorAll('.collection-grid-section .product-data');
  if (productDataElements.length === 0) {
    return;
  }
  const productDataMap = {};
  productDataElements.forEach(element => {
    const id = element.getAttribute('data-product-id');
    const title = element.getAttribute('data-product-title');
    
    productDataMap[id] = {
      id: id,
      title: title,
      handle: element.getAttribute('data-product-handle'),
      price: element.getAttribute('data-product-price'),
      bulkQuantity: element.getAttribute('data-bulk-discount-quantity'),
      bulkPrice: element.getAttribute('data-bulk-discount-price'),
      perPiecePrice: element.getAttribute('data-per-piece-price'),
      scentLabel1: element.getAttribute('data-scent-label-1'),
      scentLabel2: element.getAttribute('data-scent-label-2')
    };
    productDataMap[title] = productDataMap[id];
  });

  // console.log('Product data loaded');
  function processSearchaniseProducts() {
    // console.log('Processing Searchanise products');
    const productContainers = document.querySelectorAll('.snize-overhidden');
    if (productContainers.length === 0) {
      // console.log('No product containers found');
      return;
    }
    // console.log(`Found ${productContainers.length} product containers`);

    productContainers.forEach(container => {
      // Find the title element
      const titleElement = container.querySelector('.snize-title');
      if (!titleElement) {
        // console.log('No title element found in container');
        return;
      }
      
      const productTitle = titleElement.textContent.trim();
      // console.log('Processing container for product:', productTitle);
      
      // Find the product data
      const productData = productDataMap[productTitle];
      if (!productData) {
        // console.log('No data found for:', productTitle);
        return;
      }
      
      if (!container.classList.contains('scent-labels-added')) {
        const attributeElement = container.querySelector('.snize-attribute');
        if (attributeElement && (productData.scentLabel1 || productData.scentLabel2)) {
          const scentLabelsWrapper = document.createElement('div');
          scentLabelsWrapper.className = 'snize-scent-labels';
          
          // Create HTML for scent labels
          let labelsHTML = '';
          
          if (productData.scentLabel1) {
            labelsHTML += `<span class="snize-scent-label label-1">${productData.scentLabel1}</span>`;
          }
          
          if (productData.scentLabel2) {
            labelsHTML += `<span class="snize-scent-label label-2">${productData.scentLabel2}</span>`;
          }
          
          scentLabelsWrapper.innerHTML = labelsHTML;
          
          // Insert after the attribute element
          attributeElement.insertAdjacentElement('afterend', scentLabelsWrapper);
          container.classList.add('scent-labels-added');
          // console.log('Added scent labels to:', productTitle);
        }
      }
      if (!container.classList.contains('custom-pricing-added')) {
        // Find the add to cart button
        const addToCartButton = container.querySelector('.snize-add-to-cart-button');
        if (!addToCartButton) {
          // console.log('No add to cart button found for:', productTitle);
          return;
        }
        
        // Create the pricing wrapper
        const pricingWrapper = document.createElement('div');
        pricingWrapper.className = 'custom-pricing-wrapper';
        
        // Add pricing content based on available data
        if (productData.bulkPrice && productData.bulkQuantity) {
          pricingWrapper.innerHTML = `
            <div class="regular-price collection-custom-card-light"><span style="font-weight: normal; color: #121212;"> ${productData.price}</span><span style="font-weight: light; color: #656565; font-size: 10px;"> / pcs.</span></div>
            <div class="bulk-price collection-custom-card-light"><span style="font-weight: light; color: #656565; font-size: 10px;">Or </span><span style="font-weight: normal; color: #121212;"> ${productData.bulkPrice} </span><span style="font-weight: light; color: #656565; font-size: 10px;"> at </span><span style="font-weight: normal; color: #121212;"> ${productData.bulkQuantity}+</span></div>
          `;
        } else if (productData.perPiecePrice) {
          pricingWrapper.innerHTML = `
            <div class="regular-price collection-custom-card-light"><span style="font-weight: normal; color: #121212;">${productData.price}</span><span style="font-weight: light; color: #656565; font-size: 10px;"> / box</span></div>
            <div class="per-piece-price"><span style="font-weight: light; color: #656565; font-size: 10px;">Deal: </span><span style="font-weight: normal; color: #121212;">${productData.perPiecePrice}</span><span style="font-weight: light; color: #656565; font-size: 10px;"> / scent</span></div>
          `;
        } else {
          // console.log('No pricing data for:', productTitle);
          return;
        }
        
        // Create a new wrapper for both pricing and button
        const atcPriceWrapper = document.createElement('div');
        atcPriceWrapper.className = 'collection-atc-price-wrapper';
        
        // Move button to our new wrapper (replace the original with our wrapper)
        addToCartButton.parentNode.insertBefore(atcPriceWrapper, addToCartButton);
        
        // Add pricing and button to our wrapper
        atcPriceWrapper.appendChild(pricingWrapper);
        atcPriceWrapper.appendChild(addToCartButton);
        
        // Mark this container as processed for pricing
        container.classList.add('custom-pricing-added');
        // console.log('Added custom pricing to:', productTitle);
      }
    });
  }
  processSearchaniseProducts();
  setTimeout(processSearchaniseProducts, 1000);
  setTimeout(processSearchaniseProducts, 2500);

  // Also set up MutationObserver for dynamic content
  const observer = new MutationObserver(function(mutations) {
    let shouldProcess = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && 
          (mutation.addedNodes.length > 0 || 
           Array.from(mutation.removedNodes).some(node => node.id === 'snize_skeleton_results'))) {
        shouldProcess = true;
      }
    });
    
    if (shouldProcess) {
      // console.log('DOM changes detected, processing products');
      processSearchaniseProducts();
    }
  });
  
  // Start observing the document
  observer.observe(document.body, { childList: true, subtree: true });
  const styles = document.createElement('style');
  styles.textContent = `
   
  `;
  document.head.appendChild(styles);
}
document.addEventListener('DOMContentLoaded', function() {
  enhanceSearchaniseProducts();
});
window.addEventListener('load', function() {
  enhanceSearchaniseProducts();
});